import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import {
  AUTHENTICATED_EXTERNAL_LINK_CONFIG,
  AuthenticatedExternalLinkOptions
} from './authenticated-external-link-options';

export function provideAuthenticatedExternalLinkInterceptor(
  options: AuthenticatedExternalLinkOptions = {}
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: AUTHENTICATED_EXTERNAL_LINK_CONFIG,
      useValue: {
        routes: options.routes ?? []
      }
    }
  ]);
}
